import { render, staticRenderFns } from "./RangeInputText.vue?vue&type=template&id=10af64f6&scoped=true&lang=pug&"
import script from "./RangeInputText.vue?vue&type=script&lang=js&"
export * from "./RangeInputText.vue?vue&type=script&lang=js&"
import style0 from "./RangeInputText.vue?vue&type=style&index=0&id=10af64f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af64f6",
  null
  
)

/* custom blocks */
import block0 from "./RangeInputText.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports